import { StoreVariantColor } from '../../models';
import { soldOutSwatchImage } from '../../utils/colorSwatch';

interface ColorSwatchButtonProps {
  color: StoreVariantColor;
  selected: boolean;
  outOfStock: boolean;
  onSelect: () => void;
}

export function ColorSwatchButton({ color, selected, outOfStock, onSelect }: ColorSwatchButtonProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={outOfStock}
      title={outOfStock ? `${color.name} (sem estoque)` : color.name}
      aria-label={outOfStock ? `${color.name}, sem estoque` : color.name}
      aria-pressed={selected}
      className="group w-11 h-11 flex items-center justify-center rounded-full disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate focus-visible:ring-offset-1"
    >
      <span
        className={`block w-9 h-9 rounded-full border-2 transition-all ${
          outOfStock
            ? 'opacity-50 border-champagne-dark'
            : selected
            ? 'border-chocolate-dark scale-110 shadow-md'
            : 'border-champagne-dark group-hover:border-chocolate/60 group-hover:scale-105'
        }`}
        style={{
          backgroundColor: color.hexadecimal,
          backgroundImage: outOfStock ? soldOutSwatchImage(color.hexadecimal) : undefined,
        }}
      />
    </button>
  );
}
